import { Head, Link, router } from "@inertiajs/react"
import { Send, Users } from "lucide-react"
import { AdminLayout } from "../components/AdminLayout"
import { Card, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

const statusConfig = {
  pending: { label: "Pending", className: "bg-zinc-400 text-white hover:bg-zinc-400" },
  sending: { label: "Sending", className: "bg-amber-500 text-white hover:bg-amber-500" },
  completed: { label: "Completed", className: "bg-green-500 text-white hover:bg-green-500" },
}

export default function BroadcastsIndex({ currentUser, broadcasts = [], pendingCount }) {
  return (
    <AdminLayout currentUser={currentUser} pendingCount={pendingCount}>
      <Head title="Broadcasts - Kingdom Factor Admin" />

      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-zinc-900">Broadcasts</h1>
          <p className="text-zinc-500">Bulk emails sent to coaches, members, and guests.</p>
        </div>

        <div className="rounded-lg border border-zinc-200 bg-zinc-50 p-4 text-sm text-zinc-600 flex items-center gap-2 flex-wrap">
          <Users className="h-4 w-4 text-kf-red flex-shrink-0" />
          To send a broadcast, choose an audience on the{" "}
          <Link href="/app/admin/people" className="underline font-medium">People page</Link>{" "}
          and click “Email all …” or select specific people.
        </div>

        <Card className="bg-white border-zinc-200">
          <CardContent className="p-0">
            {broadcasts.length > 0 ? (
              <Table>
                <TableHeader>
                  <TableRow className="border-zinc-200 hover:bg-transparent">
                    <TableHead className="text-zinc-500">Subject</TableHead>
                    <TableHead className="text-zinc-500 hidden md:table-cell">Audience</TableHead>
                    <TableHead className="text-zinc-500 hidden sm:table-cell">Sent by</TableHead>
                    <TableHead className="text-zinc-500">Status</TableHead>
                    <TableHead className="text-zinc-500 text-right">Sent / Failed / Skipped</TableHead>
                    <TableHead className="text-zinc-500 hidden lg:table-cell text-right">Date</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {broadcasts.map((b) => {
                    const status = statusConfig[b.status] || statusConfig.pending
                    return (
                      <TableRow
                        key={b.id}
                        className="border-zinc-100 hover:bg-zinc-50 cursor-pointer"
                        onClick={() => router.visit(`/app/admin/broadcasts/${b.id}`)}
                      >
                        <TableCell className="font-medium text-zinc-900">{b.subject}</TableCell>
                        <TableCell className="hidden md:table-cell text-zinc-500">{b.audienceLabel}</TableCell>
                        <TableCell className="hidden sm:table-cell text-zinc-500">{b.senderName}</TableCell>
                        <TableCell>
                          <Badge className={status.className}>{status.label}</Badge>
                        </TableCell>
                        <TableCell className="text-right tabular-nums text-zinc-600">
                          {b.sentCount} / {b.failedCount} / {b.skippedCount}
                        </TableCell>
                        <TableCell className="hidden lg:table-cell text-right text-zinc-500">
                          {b.createdAt ? new Date(b.createdAt).toLocaleDateString() : ""}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            ) : (
              <div className="text-center py-12 text-zinc-400">
                <Send className="h-12 w-12 mx-auto mb-3 text-zinc-300" />
                <p className="font-medium text-zinc-500">No broadcasts yet</p>
                <p className="text-sm">Choose an audience on the People page to send your first one.</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  )
}
